__turbopack_context__.v({
  "badge": "MetricBadge-module__6mzYWq__badge",
  "card": "MetricBadge-module__6mzYWq__card",
  "label": "MetricBadge-module__6mzYWq__label",
  "root": "MetricBadge-module__6mzYWq__root",
  "value": "MetricBadge-module__6mzYWq__value",
});
